export default __webpack_public_path__ + "static/media/juguetes.736fec71.png";